import { render } from "./PaywallPlaceholder.vue?vue&type=template&id=ea0cd4a4&scoped=true"
import script from "./PaywallPlaceholder.vue?vue&type=script&setup=true&lang=js"
export * from "./PaywallPlaceholder.vue?vue&type=script&setup=true&lang=js"

import "./PaywallPlaceholder.vue?vue&type=style&index=0&id=ea0cd4a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea0cd4a4"],['__file',"src/components/Paywall/PaywallPlaceholder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ea0cd4a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ea0cd4a4', __exports__)) {
    api.reload('ea0cd4a4', __exports__)
  }
  
  module.hot.accept("./PaywallPlaceholder.vue?vue&type=template&id=ea0cd4a4&scoped=true", () => {
    api.rerender('ea0cd4a4', render)
  })

}


export default __exports__